module.exports = __webpack_public_path__ + "img/biometric_dark.9e64b453.svg";